import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Routes } from "../../configurations/config";
import { APIDateFormat } from "../Dashboard/DashboardVariables";

function ActionFormatter({ weekStart, employeeId }) {
	return (
		<Link
			to={{
				pathname: Routes.SpTimesheetStatus,
				search: `?week=${moment(weekStart).format(
					APIDateFormat
				)}&emp=${employeeId}`,
			}}
			target="_blank"
		>
			<button className="btnStyle" title="View Detail">
				<FontAwesomeIcon
					id="edit"
					className="hoverEffect"
					icon={faEye}
					size="1x"
				/>
			</button>
		</Link>
	);
}

export default ActionFormatter;
